import { TypedUseSelectorHook, useSelector } from "react-redux";
import { ApplicationState } from "./store/configureStore";

export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;